import styles from "../assets/styles/Footer.module.css";
import { Link } from "react-router-dom";

// export default function Footer() {
//     const name = process.env.REACT_APP_NAME;
//     const email = process.env.REACT_APP_EMAIL;
//     const phone = process.env.REACT_APP_PHONE;
//     const location = process.env.REACT_APP_LOCATION;

//     return (
//         <footer className={styles.footer}>
//             <div>
//                 <section>
//                     <div>
//                         <h4>{name}</h4>
//                         <div className={styles.firstSub}>
//                             <Link>
//                                 <i className="fa-brands fa-linkedin"></i>
//                             </Link>
//                             <Link>
//                                 <i className="fa-brands fa-facebook"></i>
//                             </Link>
//                             <Link>
//                                 <i className="fa-brands fa-youtube"></i>
//                             </Link>
//                             <Link>
//                                 <i className="fa-brands fa-x-twitter"></i>
//                             </Link>
//                         </div>
//                     </div>
//                     <div>
//                         <h4>Location</h4>
//                         <p>
//                             {location}
//                         </p>
//                     </div>
//                     <div>
//                         <h4>Work Inquiries</h4>
//                         <div>
//                             <p>
//                                 Email: <a href={`mailto:${email}`}>{email}</a>
//                             </p>
//                             <p>Phone/WhatsApp: <a href={`tel:${phone}`}>{phone}</a></p>
//                         </div>
//                     </div>
//                 </section>
//                 <section>
//                     <div>© 2024, {name}. Made with passion</div>
//                     <div>
//                         <Link>Privacy & Cookie Policy </Link>|
//                         <Link> Terms of Service</Link>
//                     </div>
//                 </section>
//             </div>
//         </footer>
//     );
// }
export default function Footer() {
  const name = process.env.REACT_APP_NAME;
  const email = process.env.REACT_APP_EMAIL;
  const phone = process.env.REACT_APP_PHONE;
  const location = process.env.REACT_APP_LOCATION;

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Top section */}
        <div className={styles.topSection}>
          <div className={styles.brandSocial}>
            <h4 className={styles.brandName}>{name}</h4>
            <div className={styles.socialLinks}>
              <Link to="https://github.com/Orino1" aria-label="GitHub" className={styles.socialIcon}>
                <i className="fa-brands fa-github"></i>
              </Link>
              <Link to="https://x.com/ElaoujaMohammed" aria-label="X/Twitter" className={styles.socialIcon}>
                <i className="fa-brands fa-x-twitter"></i>
              </Link>
            </div>
          </div>

          <div className={styles.location}>
            <h4>Location</h4>
            <p>{location}</p>
          </div>

          <div className={styles.contact}>
            <h4>Work Inquiries</h4>
            <p>
              Email: <a href={`mailto:${email}`} className={styles.contactLink}>{email}</a>
            </p>
            <p>
              Phone/WhatsApp: <a href={`tel:${phone}`} className={styles.contactLink}>{phone}</a>
            </p>
          </div>
        </div>

        {/* Bottom section */}
        <div className={styles.bottomSection}>
          <div className={styles.copy}>
            © 2025, {name}. Made with passion
          </div>
        </div>
      </div>
    </footer>
  );
}